import { Text } from "@tblabs/truffle";
import { Box } from "./Box";
import { RentBasketItem } from "../../../Services/Basket/RentBasketItem";


export class RentSummaryBox extends Box
{
    constructor(item: RentBasketItem)
    {
        super("product__summary", [
            new Box("product__summary-main product__summary-main--vertical", [
                new Text(item.ExtraInfo).Style(`border-left: 8px solid #c3185a; padding: 8px; white-space: normal; margin-bottom: 16px; border-radius: 0; color: #eaeaea`)
                    .VisibleWhen(item.ExtraInfo, v => v.length > 0, "inline"),
                new Box("product__summary-row", [
                    new Text(item.FinalPriceBeforeDiscount, v => v + "zł")
                        .Class("product__summary-price-original")
                        .Attribute("data-testid", "final-price-before-discount-value")
                        .VisibleWhen(item.FinalPriceAfterDiscount, v => v != item.FinalPriceBeforeDiscount.value, "flex"),
                ]),
                new Box("product__summary-row", [
                    new Box("product__summary-price", [
                        new Text(item.FinalPriceAfterDiscount).Attribute("data-testid", "final-price-after-discount-value"),
                        " zł za ",
                        new Text(item.Dates.DaysCount).Attribute("data-testid", "days-count-value"),
                        " ", new Text(item.Dates.DaysCount, v => v === 1 ? "dzień" : "dni"),
                    ]),
                ]),
                new Box("product__summary-row product__summary-row--deposit", [
                    new Text(item.FinalDeposit, v => "+ " + v + " zł kaucji zwrotnej")
                        .Attribute("data-testid", "final-deposit-value"),
                ]),
            ]).PaddingTop(0).MarginTop(0).BorderRadius(0),
        ]);
    }
}
